@if (change) {
  <div class="planning-draft-job-change-diff">

    @if (change.changed; as changed) {
      @if (changed.changedFields?.length) {
        <div class="tr diff-row">
          <div class="th" translate>Field</div>
          <div class="th" translate>Previous</div>
          <div class="th" translate>Current</div>
          <div class="th"></div>
        </div>

        @if (changed.sla) {
          <app-pending-field-row [field]="fields.SLA" [pendingField]="changed.sla" [blocked]="isBlocked(fields.SLA)"></app-pending-field-row>
        }
        @if (changed.tags) {
          <app-pending-field-row [field]="fields.TAGS" [pendingField]="changed.tags" [blocked]="isBlocked(fields.TAGS)"></app-pending-field-row>
        }
        @if (changed.skills) {
          <app-pending-field-row [field]="fields.SKILLS" [pendingField]="changed.skills" [blocked]="isBlocked(fields.SKILLS)"></app-pending-field-row>
        }
        @if (changed.packed) {
          <app-pending-field-row [field]="fields.PACKED" [pendingField]="changed.packed" [blocked]="isBlocked(fields.PACKED)"></app-pending-field-row>
        }
        @if (changed.accountId) {
          <app-pending-field-row [field]="fields.ACCOUNT_ID" [pendingField]="changed.accountId" [blocked]="isBlocked(fields.ACCOUNT_ID)"></app-pending-field-row>
        }
        @if (changed.pricePlanProgramType) {
          <app-pending-field-row [field]="fields.PRICE_PLAN_PROGRAM_TYPE" [pendingField]="changed.pricePlanProgramType" [blocked]="isBlocked(fields.PRICE_PLAN_PROGRAM_TYPE)"></app-pending-field-row>
        }
      }

      <!-- Packages -->
      @if (changed.packages && !changed.packages.isEmpty) {
        <app-planning-draft-job-package-delta [packages]="changed.packages"></app-planning-draft-job-package-delta>
      }

      <!-- Stops -->
      @if (changed.isStopsChanged) {
        @for (stop of changed.stops; track stop.stopId) {
          <app-planning-draft-job-stop-change [stop]="stop"></app-planning-draft-job-stop-change>
        }
      }
    }

    <!-- Split plan -->
    @if (change.splitPlan) {
      <app-planning-draft-job-split-plan [splitPlan]="change.splitPlan"></app-planning-draft-job-split-plan>
    }
  </div>
}
